import { VImg } from 'vuetify/lib/components/VImg';

var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"pa-1 d-inline-block"},[_c(VImg,{attrs:{"max-width":"30","max-height":"30","src":_vm.props.logoUrl,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }